<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input size="small" v-model="searchForm.product_name" placeholder="请输入产品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="佣金状态" v-auth="'/order/order/settled'">
          <el-select size="small" v-model="searchForm.agent_log_status" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="10"></el-option>
            <el-option label="已结算" value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit" >查询</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="typeName" @tab-click="handleTypeClick">
          <el-tab-pane label="队列一" name="one"></el-tab-pane>
          <el-tab-pane label="队列二" name="two"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'待收货/已发货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column type="selection"></el-table-column> -->
          <el-table-column prop="order_no" label="订单信息" width="300" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text state-text-blue" :class="{'state-text-red':scope.row.queue_type != 0}">{{scope.row.queue_number}}</span>

                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
                <span class="pl16" v-if="scope.row.remark">后台备注：{{ scope.row.remark }}</span>
              </div>
              <template v-else>
                  <div class="product-info" v-for="(item, index) in scope.row.product" :key="index" v-if="(supply_id>0&&item.supply_id==supply_id)||supply_id==0" >
                  <div class="pic"><img v-img-url="item.image?item.image.file_path:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.state_text }}</div>
              <div v-if="scope.row.cancel_check_time_text">取消审批时间：{{ scope.row.cancel_check_time_text }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user?scope.row.user.mobile:''}}</span>
              <br />
              <span v-if="scope.row.reserve_date||scope.row.reserve_time">预约时间:{{scope.row.reserve_date?scope.row.reserve_date:''}} {{scope.row.reserve_time?scope.row.reserve_time:''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column prop="logistics" label="发货仓库" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics">{{ scope.row.logistics.name }}({{ scope.row.logistics.logistics_id }})</span>
              <span v-else>平台</span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_log_status" label="佣金状态" width="80" align="center">
            <template slot-scope="scope" v-if="scope.row.is_agent">
              <span v-if="scope.row.agent_log_status == 20" class="green">已结算</span>
              <span v-else-if="scope.row.agent_log_status == 10">未结算</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button v-if="(supply_id>0&&supply_setting.order_detail>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import QueuerebateApi from '@/api/queuerebate.js';
import qs from 'qs'
export default {
  components:{

  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        product_name:"",
        order_no: '',
        create_time: '',
        agent_log_status: '',
      },
      typeName: 'one',
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /* 物流中心 */
      logisticsList:[],
      /* 是否开启物流中心 */
      is_open_logistics:false,
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      supply_id:0,
      supply:{},
       open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,
      is_admin_remark: false,
      remarkForm: {
        order_id: '',
        remark: '',
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    handleTypeClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      if(self.typeName=='one'){
        Params.queue_type = 0;
      } else {
        Params.queue_type = 1;
      }
      self.loading = true;
      QueuerebateApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              queue_type: item.queue_type,
              queue_number: item.queue_number,
              is_top_row: true,
              remark: item.remark
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.shopList = res.data.shop_list;
          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          console.log(self)
          self.logisticsList = res.data.logistics_list;
          self.is_open_logistics = res.data.is_open_logistics
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },

    handleCopy(text, event) {
      clip(text, event)
    },

  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-blue{ background: #3a8ee6;}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/queuerebate/order/index.vue